import { Container } from "./Container";
import { Button } from "./Button";
import { StatusPill } from "./StatusPill";
import { Icon } from "./Icon";
import { siteConfig } from "../data/portfolio";

/** Full hero: blue/cyan radial washes, faded 48px grid, gradient headline, portrait. */
export function Hero() {
  return (
    <section
      id="top"
      className="border-hairline relative isolate overflow-hidden border-b"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-20 [background:var(--wash-hero)]"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-10 opacity-40 [background-image:linear-gradient(to_right,var(--grid-line)_1px,transparent_1px),linear-gradient(to_bottom,var(--grid-line)_1px,transparent_1px)] [background-size:var(--grid-size)_var(--grid-size)] [mask-image:linear-gradient(to_bottom,black,transparent_85%)]"
      />

      <Container className="grid items-center gap-10 py-12 md:grid-cols-[minmax(0,1fr)_minmax(16rem,0.7fr)] md:gap-8 md:py-16 lg:grid-cols-[minmax(0,1.2fr)_minmax(22rem,0.8fr)] lg:gap-14 lg:py-20">
        <div>
          <StatusPill>{siteConfig.availability}</StatusPill>
          <p className="text-muted mt-8 mb-5 text-sm font-semibold tracking-eyebrow uppercase">
            {siteConfig.role}
          </p>
          <h1 className="text-strong text-4xl leading-[1.05] font-semibold tracking-display text-balance md:text-5xl lg:text-6xl">
            {siteConfig.headline}
            <span className="block bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent">
              {siteConfig.headlineAccent}
            </span>
          </h1>
          <div className="text-body mt-7 grid max-w-2xl gap-4 text-lg leading-8 text-pretty">
            {siteConfig.intro.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>

          <div className="mt-10 flex flex-wrap gap-3">
            <Button variant="primary" icon="arrow" href="#projects">
              View selected work
            </Button>
            <Button
              variant="secondary"
              icon="mail"
              iconPosition="left"
              href="#contact"
            >
              Start a conversation
            </Button>
          </div>

          <div className="text-muted mt-10 flex flex-wrap items-center gap-6 text-sm">
            <span className="inline-flex items-center gap-2">
              <Icon name="map-pin" size={16} />
              {siteConfig.location}
            </span>
            {siteConfig.socialLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-muted hover:text-strong inline-flex items-center gap-2 transition"
              >
                <Icon name={link.icon} size={16} />
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="relative w-full max-w-72 justify-self-center md:max-w-88 md:justify-self-end lg:max-w-md">
          <div
            aria-hidden="true"
            className="absolute -inset-8 -z-10 bg-[radial-gradient(circle_at_55%_45%,rgb(59_130_246/0.28),transparent_62%)] blur-[48px]"
          />
          <img
            src={siteConfig.portrait.src}
            alt={siteConfig.portrait.alt}
            width={896}
            height={1344}
            // Above the fold and the largest paint on the page — never defer it.
            fetchPriority="high"
            decoding="async"
            className="block h-auto w-full drop-shadow-[0_0_28px_rgb(96_165_250/0.35)]"
          />
        </div>
      </Container>
    </section>
  );
}
